import * as React from 'react';

import { cn } from '@/lib/cn';

type ChoiceChipProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  selected?: boolean;
};

export const ChoiceChip = React.forwardRef<HTMLButtonElement, ChoiceChipProps>(
  ({ selected = false, className, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'rounded-full border px-4 py-3 text-left text-sm transition-all duration-base ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
          selected
            ? 'border-accent bg-bg-secondary text-text-primary'
            : 'border-border bg-bg text-text-primary hover:bg-bg-secondary',
          className,
        )}
        {...props}
      >
        {children}
      </button>
    );
  },
);

ChoiceChip.displayName = 'DSChoiceChip';
